import React from 'react';
import './Page.css';

const TermsOfService = () => {
  return (
    <div className="page-container">
      <h1>Terms of Service</h1>
      <div className="page-content">
        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using Gold Price Tracker, you accept and agree to be bound by the terms and provision of this agreement.</p>
        </section>

        <section>
          <h2>2. Use License</h2>
          <p>Permission is granted to temporarily access the materials on Gold Price Tracker's website for personal, non-commercial transitory viewing only.</p>
        </section>

        <section>
          <h2>3. Disclaimer</h2>
          <p>The materials on Gold Price Tracker's website are provided on an 'as is' basis. Gold Price Tracker makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
        </section>

        <section>
          <h2>4. Limitations</h2>
          <p>In no event shall Gold Price Tracker or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Gold Price Tracker's website.</p>
        </section>

        <section>
          <h2>5. Accuracy of Materials</h2>
          <p>The materials appearing on Gold Price Tracker's website could include technical, typographical, or photographic errors. Gold Price Tracker does not warrant that any of the materials on its website are accurate, complete, or current.</p>
        </section>

        <section>
          <h2>6. Links</h2>
          <p>Gold Price Tracker has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Gold Price Tracker of the site.</p>
        </section>

        <section>
          <h2>7. Modifications</h2>
          <p>Gold Price Tracker may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>These terms and conditions are governed by and construed in accordance with the laws and you irrevocably submit to the exclusive jurisdiction of the courts in that location.</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService; 